import React from 'react';
import styled from 'styled-components';
import { Button as MUIButton, ButtonProps } from '@material-ui/core';

interface IProps extends ButtonProps {
    loading?: boolean;
    small?: boolean;
}

const BaseButton = ({ loading, small, ...other }: IProps) => (
    <MUIButton disabled={loading} {...other} />
);

export const Button = styled(BaseButton)`
    height: ${({ small }) => (small ? '40px' : '65px')};
    background-color: ${({ theme }) => theme.palette.action.active};
    border-radius: 75px;
    text-transform: none;
    padding: 0 40px;

    :hover {
        background-color: ${({ theme }) => theme.palette.action.hover};
    }

    :disabled {
        background-color: ${({ theme }) => theme.palette.action.disabled};
        color: ${({ theme }) => theme.palette.background.paper};
    }

    .MuiButton-label {
        font-size: ${({ theme }) => theme.typography.body1.fontSize};
        color: ${({ theme }) => theme.palette.background.paper};
        font-weight: 700;
    }
`;
